import React from "react";

const CartContext = React.createContext({
  items: [],
  ingredients: [],
  addItem: (item) => {},
  removeItem: (id) => {},
  findIngredient: (id) => {},
  clearItem: (id) => {},
  saveCart: () => {},
  clearCart: () => {},
});

export default CartContext;
